module.exports = __webpack_public_path__ + "img/send-message.8d58a2fd.svg";